import React, {Dispatch, SetStateAction} from 'react';

import QuobisService from '../services/QuobisService';

/*
Routing context
 */
export interface IRouterContext {
	route: string;
	setRoute: Dispatch<SetStateAction<IRouterContext['route']>>;
}
export const RouterContext = React.createContext<IRouterContext | null>(null);
export const RouterProvider = RouterContext.Provider;

/*
Quobis context
 */
export const QuobisServiceContext = React.createContext<typeof QuobisService | null>(null);
export const QuobisServiceProvider = QuobisServiceContext.Provider;
